/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Input } from '../input/input';
import { InputProps } from 'interfaces';
import { CypressI } from 'interfaces/cypress';
import { FieldValues, UseFormSetValue } from 'react-hook-form';

interface InputEmailProps {
	setValueCustom?: UseFormSetValue<FieldValues>;
}

export const InputEmail: React.FC<
	InputProps &
		InputEmailProps &
		CypressI &
		React.InputHTMLAttributes<HTMLInputElement>
> = ({ rules, setValueCustom, ...props }) => {
	const LIMIT = 40;
	const onKeyDownHandler = (event: any): void => {
		const code = event.which || event.keyCode;
		if (code === 32) event.preventDefault();
	};

	const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>): void => {
		event.preventDefault();
		const pastedText = event.clipboardData.getData('text').trim();
		const input = event.target as HTMLInputElement;
		input.value = pastedText;
		setValueCustom &&
			setValueCustom(props.name, pastedText, {
				shouldDirty: true,
				shouldValidate: true,
			});
	};

	const finalRules = React.useMemo(() => {
		return {
			...rules,
			pattern: {
				value: /^[\w+\-.]+(\.[\w+\-.]+)*@[\w-]+(\.[\w-]+)*(\.[a-z]{2,})$/,
				message: 'Please enter a valid email address.',
			},
			maxLength: {
				value: LIMIT,
				message: 'Your email address has to have less than 40 characters',
			},
		};
	}, [rules]);

	return (
		<>
			<Input
				type="text"
				rules={finalRules}
				onChangeCustom={(e: any) => {
					if (e.target.value.length > LIMIT) {
						e.target.value = e.target.value.substr(0, LIMIT);
					}
				}}
				onPaste={handlePaste}
				onKeyDown={onKeyDownHandler}
				{...props}
			></Input>
		</>
	);
};
